import { UnrangedPlanogramContainer } from "@CommonTypes/merchflow/pog/container";
import { useRef } from "react";
import { Color, Flex, Icon, Text } from "src/elements";
import { Transition } from "src/utils";
import { colorToRGBA } from "src/utils/colorToRgba";
import { useHoverClickable } from "src/utils/hoverClickable";
import { styled } from "styled-components";

const UnrangedContainerElement = styled(Flex)`
  background-color: ${({ background }) => background && colorToRGBA(background, 0.8)};
  border: ${({ background }) => background && `1px solid ${colorToRGBA(background, 0.2)}`};
`;

const ContainerIcon = styled(Flex)`
  filter: drop-shadow(1px 1px 3px black);
  transition: opacity ${Transition.fast};
`;

interface Props {
  container: UnrangedPlanogramContainer;
  restoreContainer: (container: UnrangedPlanogramContainer) => void;
}

export const UnrangedContainer = ({ container, restoreContainer }: Props) => {
  const refContainer = useRef(null);
  const { isHovered } = useHoverClickable(refContainer);

  return (
    <UnrangedContainerElement
      ref={refContainer}
      width="100%"
      background={container.color}
      borderRadius="3px"
      padding="10px"
      align="center"
      justify="between"
    >
      <Text variant="caption2" color={Color.white} textShadow="1px 1px 3px black">
        {container.getLabel()}
      </Text>

      <ContainerIcon
        opacity={isHovered ? 1 : 0}
        padding="5px"
        onClick={() => restoreContainer(container)}
      >
        <Icon name="undo" color={Color.white} />
      </ContainerIcon>
    </UnrangedContainerElement>
  );
};
